import { useIntl } from 'react-intl';

import { useTenantSlug } from '~/features/tenant/helpers';
import { TenantService } from '~/services/api/tenant/endpoints';
import { useIntakeChannel } from '~/slices/intakeChannelSlice';

export const useReportStatusOptions = () => {
  const slug = useTenantSlug();
  const selectedChannel = useIntakeChannel().intakeChannelData.selectedChannel;
  const intl = useIntl();

  const query = TenantService.endpoints.intakeChannelProgramDetails.useQuery(
    { slug, intakeChannelId: selectedChannel ?? 0 },
    { skip: !selectedChannel || !slug },
  );

  const statusOptions = query.data?.report_configuration?.choices
    .status_choices ?? [
    {
      label: intl.formatMessage({ defaultMessage: 'New Report' }),
      order: 2,
      value: 0,
      is_closed: false,
    },
    {
      label: intl.formatMessage({ defaultMessage: 'Under Review' }),
      order: 3,
      value: 1,
      is_closed: false,
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Pending Further Information',
      }),
      order: 4,
      value: 2,
      is_closed: false,
    },
    {
      label: intl.formatMessage({ defaultMessage: 'Closed' }),
      order: 5,
      value: 3,
      is_closed: true,
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Closed - Reporter Initiated',
      }),
      order: 6,
      value: 5,
      is_closed: true,
    },
    {
      label: intl.formatMessage({ defaultMessage: 'Archived' }),
      order: 7,
      value: 6,
      is_closed: true,
    },
  ];

  return { statusOptions };
};
